import { render, staticRenderFns } from "./CampoClientEmailFacturacion.vue?vue&type=template&id=d6bf3982&scoped=true"
import script from "./CampoClientEmailFacturacion.vue?vue&type=script&lang=js"
export * from "./CampoClientEmailFacturacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6bf3982",
  null
  
)

export default component.exports